import axios from 'axios'
import AllRoutes from '../../nametitle/AllRoutes'
import { baseUrl } from '../../nametitle/dataUrl'
import { saveDataToFile } from '../SearchAction'
import { Localvalue } from '../../nametitle/localValue'




// Add Temoignage
export const CreateTemoignage = async (
  title,
  coverPicture,
  description,
  content,
  video,
  audio,
  redirect
) => {
  var data = JSON.stringify({
    title: title,
    description: description,
    coverPicture: coverPicture,
    content: content,
    video: video,
    audio: audio
  })
  var config = {
    method: 'post',
    url: `${baseUrl.baseUrl}/api/v1/temoignages/`,
    headers: {
      Authorization: `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      Cookie: 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  }
  await axios(config)
    .then(function (response) {
      alert('Creation réussi')
      //console.log(JSON.stringify(response.data))
      return redirect(`/${AllRoutes.admin}/${AllRoutes.temoins}`)
    })
    .catch(function (error) {
      alert(error.message)
      //console.log(error)
    })
}


// Mise ajour du Témoignage
export const UpdateTemoignageAction = (
  id,
  title,
  coverPicture,
  description,
  content,
  video,
  audio,
  redirect
) => {
  var data = JSON.stringify({
    title: title,
    description: description,
    coverPicture: coverPicture,
    content: content,
    video: video,
    audio: audio
  })
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/temoignages/${id}`,
    headers: {
      Authorization: `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      Cookie: 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  }
  axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data))
      //redirect(`/${AllRoutes.admin}/${AllRoutes.temoins}`);
      alert('Modifiecation réussi')
      // window.location.reload();
      redirect(`/${AllRoutes.admin}/${AllRoutes.temoins}`)
    })
    .catch(function (error) {
      //console.log(error)
    })
}


export const StopTemoignage = id => {
  var data = JSON.stringify({
    visible: Boolean(false)
  })
  var config = {
    method: 'get',
    url: `${baseUrl.baseUrl}/api/v1/temoignages/hide/${id}`,
    headers: {
      'Content-Type': 'application/json',
      Cookie: 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  }
  axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data))
      alert(response.data.message)
      window.location.reload()
    })
    .catch(function (error) {
      //console.log(error)
    })
}


// ********************************************* Rendre visible temoignage
export const AccessTemoignage = id => {
  var data = JSON.stringify({
    visible: Boolean(true)
  })
  var config = {
    method: 'get',
    url: `${baseUrl.baseUrl}/api/v1/temoignages/show/${id}`,
    headers: {
      'Content-Type': 'application/json',
      Cookie: 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  }
  axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data))
      alert(response.data.message)
      window.location.reload()
    })
    .catch(function (error) {
      //console.log(error)
    })
}


// Recupérer tout les temoignages
export const LoadAllTemoignage = (SetState, SetState2) => {
  var options = {
    method: 'GET',
    url: `${baseUrl.baseUrl}/api/v1/temoignages/get/all`,
    headers: {
      'Content-Type': 'application/json'
    }
  }
  axios(options)
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      saveDataToFile(response.data.data,Localvalue.temoignagesData);
      SetState(response.data.data)
      SetState2(response.data.data)
    })
    .catch(function (error) {
      //console.log(error)
    })
}


// Recupérer tout les temoignages
export const LoadAllTemoignageId = (
  id,
  title,
  coverPicture,
  content,
  video,
  audio,
  description
) => {
  var options = {
    method: 'GET',
    url: `${baseUrl.baseUrl}/api/v1/temoignages/${id}`,
    headers: {
      'Content-Type': 'application/json'
    }
  }
  axios(options)
    .then(function (response) {
      title(response.data.data.title)
      description(response.data.data.description)
      coverPicture(response.data.data.coverPicture)
      content(response.data.data.content)
      video(response.data.data.video)
      audio(response.data.data.audio)
    })
    .catch(function (error) {
      //console.log(error)
    })
}


export const LoadAllTemoignageIdPUT = (
  id,
  settitle,
  setcoverPicture,
  setdescription,
  setcontent,
  setvideo,
  setaudio
) => {
  var options = {
    method: 'GET',
    url: `${baseUrl.baseUrl}/api/v1/temoignages/${id}`,
    headers: {
      'Content-Type': 'application/json'
    }
  }
  axios(options)
    .then(function (response) {
      settitle(response.data.data.title)
      setdescription(response.data.data.description)
      setcontent(response.data.data.content)
      setcoverPicture(response.data.data.coverPicture)
      setvideo(response.data.data.video)
      setaudio(response.data.data.audio)
      //console.log(JSON.stringify(response.data));
    })
    .catch(function (error) {
      //console.log(error)
    })
}
